export enum EffectTypeWire {
  date = 'date',
  deadline = 'deadline',
  lastTime = 'lastTime',
  progress = 'progress',
  snooze = 'snooze',
}
